<template>
  <b-modal id="dropFirstVersionModal" title="Сброс шагов этапа" ref="dropFirstVersionModal"
           header-bg-variant="primary" header-text-variant="light"
           ok-title="Подтвердить" cancel-title="Отмена" ok-variant="primary"
           cancel-variant="outline-primary" @ok="onOk"
  >
    <div class="mt-2">
      Вы действительно хотите обнулить проделанные действия в этапе {{stageName}}?
    </div>
  </b-modal>
</template>

<script>
export default {
  name: 'DropFirstVersionStage',
  methods: {
    onOk() {
      this.$emit('acceptDrop')
    }
  },
  props: {
    stageName: {
      type: String,
      default() {
        return ''
      }
    }
  }
}
</script>

<style scoped>

</style>
